import React from 'react';
import { getAppleUserProfile, confirmAppleUser } from '../../api/oauthApi';
import { OAuthConfirmationPage } from '../../components/OAuthConfirmation';

const appleProviderConfig = {
    testIdPrefix: 'apple-confirmation.page',
    getUserProfile: getAppleUserProfile,
    confirmUser: confirmAppleUser,
    idFieldName: 'appleId',
    testIds: {
        guardianSpan: 'auth.apple.span-250',
        playerDetailsImg: 'auth.apple.img-256',
        dobImg: 'auth.apple.img-347',
        location: 'appleauthconfirmationpage.location-location',
        parentsNotice: 'apple-confirmation.page.parents-notice',
    },
};

const AppleAuthConfirmationPage = () => (
    <OAuthConfirmationPage providerConfig={appleProviderConfig} />
);

export default AppleAuthConfirmationPage;
